<div class="table-responsive" [class.overflow-hidden]="parkingPassService.emptyRowService.emptyRow.length > 0">
    <table class="table table-striped table-hover footable">
        <thead>
            <tr [ngClass]="{'noSort': parkingPassService.data.allParkingPasses.data.length < 2}">
                <th style="width: 50px;"></th>
                <th (click)="orderBy('bookingNumber', $event)">
                    <span>ID#</span>
                    <span class="footable-sort-indicator"></span>
                </th>
                <th (click)="orderBy('suite.suiteNumber', $event)" *ngIf="!authenticationService.userIsResident">
                    <span>Unit</span>
                    <span class="footable-sort-indicator">
                    </span>
                </th>
                <th *ngIf="parkingPassService.buildings.length > 1 && !authenticationService.userIsResident"
                    (click)="orderBy('building.buildingName', $event)">
                    <span>Building</span>
                    <span class="footable-sort-indicator"></span>
                </th>
                <th (click)="orderBy('bookingParkingLot.name', $event)" *ngIf="!isOnlyOneLotExists()">
                    <span>Parking Lot</span>
                    <span class="footable-sort-indicator"></span>
                </th>
                <th class="cursor-default">
                    <span>Pass Type</span>
                </th>
                <th (click)="orderBy('visitor.licensePlate', $event)">
                    <span>License</span>
                    <span class="footable-sort-indicator"></span>
                </th>
                <th (click)="orderBy('visitor.vehicle', $event)">
                    <span>Vehicle</span>
                    <span class="footable-sort-indicator"></span>
                </th>
                <th>
                    <span>Status</span>
                </th>
                <th (click)="orderBy('createdBy.fullName', $event)">
                    <span>Created By</span>
                    <span class="footable-sort-indicator"></span>
                </th>
            </tr>
        </thead>
        <tbody>
            <ng-template ngFor let-item [ngForOf]="parkingPassService.data.allParkingPasses.data" let-index="index">
                <tr [ngClass]="{'footable-odd': (index % 2 === 0)}" (click)="$event.showDropdown || toggleCheck(item)">
                    <td>
                        <label class="img-checkbox">
                            <input type="checkbox" [ngModel]="item.checked">
                            <label><svg-checked></svg-checked></label>
                        </label>
                    </td>
                    <td>
                        <div class="table-mobile-left">
                            <span>ID#</span>
                        </div>
                        <span>{{item.bookingNumber}}</span>
                    </td>
                    <td *ngIf="!authenticationService.userIsResident">
                        <div class="table-mobile-left">
                            <span>Unit</span>
                        </div>
                        <span>{{item.suiteNumber}}</span>
                    </td>
                    <td *ngIf="parkingPassService.buildings.length > 1 && !authenticationService.userIsResident">
                        <div class="table-mobile-left">
                            <span>Building</span>
                        </div>
                        <span>{{item.buildingName}}</span>
                    </td>
                    <td *ngIf="!isOnlyOneLotExists()" (click)="$event.showDropdown = true;">
                        <div class="table-mobile-left">
                            <span>Parking Lot</span>
                        </div>
                        <span>{{item.bookingParkingLot.name}}</span>
                    </td>
                    <td class="table-hint-td">
                        <div class="clickable-text mtv-primary-color" (click)="showHint($event)">
                            {{getPassTypesStringForBooking(item)}}
                        </div>
                        <div class="table-hint {{index > 7 ? 'up' : 'down'}}">
                            <div *ngFor="let pass of item.bookingPassTypes">
                                <span>{{(pass.passTypeName.length > 15) ? (pass.passTypeName | slice:0:15)+'...' : pass.passTypeName}}</span>
                                {{pass.dateFrom | date:'dd.MM.yyyy hh:mm a':'+0000'}} - {{pass.dateTo | date:'dd.MM.yyyy hh:mm a':'+0000'}}
                            </div>
                        </div>
                    </td>
                    <td>
                        <div class="table-mobile-left">
                            <span>License</span>
                        </div>
                        <span>{{item.visitorLicensePlate}}</span>
                    </td>
                    <td>
                        <div class="table-mobile-left">
                            <span>Vehicle</span>
                        </div>
                        <span>{{item.visitorVehicle}}</span>
                    </td>
                    <td class="text_lable">
                        <div class="table-mobile-left">
                            <span>Status</span>
                        </div>
                        <div class="table-mobile-right">
                            <span *ngIf="item.status === 'approved'">
                                <span *ngIf="item.timeRelatedStatus === 'current'" class="label label-current">
                                    Current
                                </span>
                                <span *ngIf="item.timeRelatedStatus === 'future'" class="label label-future">
                                    Future
                                </span>
                                <span *ngIf="item.timeRelatedStatus === 'past'" class="label label-past">
                                    Past
                                </span>
                            </span>
                            <span *ngIf="item.status === 'pending'" class="label label-pending">
                                Pending
                            </span>
                            <span *ngIf="item.status === 'declined'" class="label label-declined">
                                Declined
                            </span>
                        </div>
                    </td>
                    <td>
                        <div class="table-mobile-left">
                            <span>Created By</span>
                        </div>
                        <span>{{item.createdBy}}</span>
                    </td>
                </tr>
            </ng-template>
            <tr *ngFor="let item of parkingPassService.emptyRowService.emptyRow" class="empty-row" style="cursor: default;">
                <td></td>
                <td>&nbsp;</td>
                <td *ngIf="!authenticationService.userIsResident"></td>
                <td *ngIf="parkingPassService.buildings.length > 1 && !authenticationService.userIsResident"></td>
                <td *ngIf="!isOnlyOneLotExists()"></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
            </tr>
        </tbody>
    </table>

    <empty-result-message [isEmpty]="!parkingPassService.data.allParkingPasses.total"
                          [isServiceUnavailable]="parkingPassService.showServiceUnavailable"
                          [isLoading]="parkingPassService.spinnerShow">
        You have no parking passes listed on the system<br>
        <span *ngIf="parkingPassService.canEdit() && (parkingPassService.residentParkinglots.length > 0 || !authenticationService.userIsResident) && (parkingPassService.buildings.length || authenticationService.userIsResident)">
            <a href="javascript://" (click)="parkingPassService.isParkingPassModalShow = true" class="mtv-primary-color clickable-text">add a pass</a> now
        </span>
    </empty-result-message>
</div>



// WEBPACK FOOTER //
// /app/src/app/views/parking-pass/parking-pass-list/parking-pass-list.component.html